// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiURL: "https://www.test.satsang.org.in/org/api/v1",
  // apiURL: "http://localhost:8000/org/api/v1",
  mapServerURL: "https://satsang.org.in/geoserver/satsang/wms",
  //apiURL: "http://localhost:8080/org/api/v1"
  ssoURL: 'https://sso2.test.satsang.org.in',
  activityLogoutTimeInMins: 10,
  // localhostUrl: 'http://localhost:4200/signin-load',// comment out for development 
    localhostUrl: '',

  orgUrl: 'https://www.test.satsang.org.in/signin-load?login=true',
  accoUrl: 'https://dev.acco.satsang.org.in',
  onlineIvUrl: 'https://oblation.test.satsang.org.in',
  timeBeforeCallingRefreshInSecs: 15
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
